
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import DatabasePicker from "@/components/pickers/DatabasePicker.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import {AlacakTuruEntity} from "@/entity/AlacakTuruEntity";

@Component({
  components: {DatabasePicker},
})
export default class AlacakTuruPicker extends Mixins(SimpleInputMixin) {
  @Prop() returnId !: any;
  @Prop() returnObject!: string | boolean;
  @Prop() rules!: string;
  @Prop({required: true}) alacakBelgeTuruId!: number;
  @Prop({required: true}) takipTipiId!: number;
  @Prop({default:'Alacak Kalemi Türü Seçiniz*'}) label !: string;
  @Prop({default: false}) defaultFirstItem!: boolean;

  localValue!: number | AlacakTuruEntity;
  items: Array<AlacakTuruEntity> = [];

  get message(): string {
    return this.takipTipiId && this.alacakBelgeTuruId ? "" : "Lütfen gerekli parametreleri sağlayın";
  }

  get action(): string {
    return `/api/v1/takip-tipi/${this.takipTipiId}/alacak-belge-turu/${this.alacakBelgeTuruId}/alacak-kalemi-turleri`;
  }

  get isReturnId() {
    return this.returnId || this.returnId === "";
  }

  get isReturnObject() {
    return this.returnObject || this.returnObject === "";
  }

  mounted() {
    this.load();
  }

  load() {
    if (this.isReturnObject) {
      this.$helper.requestWithCache(this.action)
          .then((response: any) => {
            this.items = response.data;
            if (this.localValue && !this.items.find((item) => (item.id == this.localValue)))
              delete this.$data.localValue;
          });
    }
  }

  @Watch('takipTipiId')
  @Watch('alacakBelgeTuruId')
  onParametersChange() {
    if (this.isReturnObject) {
      this.load();
    }
  }

  onAlacakTuruChange(v: AlacakTuruEntity) {
    this.$emit('alacak-turu', v);
    this.input();
  }
}
